import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import {LiveComponentToolsController} from "app/stimulus/live-component-tools-controller";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";
import {Component} from "@symfony/ux-live-component";
import {LiveComponentAwareController} from "app/stimulus/live-component-aware-controller";

@AsStimulusController('card-transactions')
export default class extends Typed(
    LiveComponentAwareController(LiveComponentToolsController(Controller<HTMLElement>)), {
        values: {
            nextId: String,
        },
        targets: {
            item: HTMLElement,
            loader: HTMLElement,
        }
    }
)
{
    declare private loaderObserver: IntersectionObserver;
    declare private onComponentRenderFinished: () => void;

    public initialize(): void {
        this.loaderObserver = new IntersectionObserver((entries) => {
            if (entries.some(entry => entry.isIntersecting)) {
                this.loaderTargets.forEach((target) => this.loaderObserver.unobserve(target));
                this.loadMoreItems().catch((e) => console.error(e));
            }
        });
        this.onComponentRenderFinished = () => {
            this.loaderTargets.forEach((target) => this.loaderObserver.observe(target));
        }
    }

    public disconnect(): void {
        this.loaderObserver.disconnect();
    }

    public liveComponentConnect(component: Component): void {
        component.on('render:finished', this.onComponentRenderFinished);
    }

    public liveComponentDisconnect(component: Component): void {
        component.off('render:finished', this.onComponentRenderFinished);
    }

    public loaderTargetConnected(element: HTMLElement): void {
        this.loaderObserver.observe(element);
    }

    public loaderTargetDisconnected(element: HTMLElement): void {
        this.loaderObserver.unobserve(element);
    }

    public async loadMoreItems(): Promise<void> {
        const component = await this.getComponent();
        let lastElementId = this.itemTargets.length > 0
            ? this.itemTargets[this.itemTargets.length - 1].id
            : undefined;
        if (typeof lastElementId !== 'string' || !this.hasNextIdValue) {
            return;
        }
        await component.action('loadMoreItems', {nextId: this.nextIdValue, lastElementId: lastElementId});
    }
}
